import React from 'react'
import { useRecordContext } from 'react-admin'

const DomainName = () => {
  const record = useRecordContext()
  return <span>Domain {record ? `"${record.alias}"` : ''}</span>
}

export default DomainName
